import {initializeApp} from 'firebase/app';
import {browserLocalPersistence, initializeAuth} from "@firebase/auth";

// Configure Firebase.
export const firebaseConfig = {
    apiKey: "AIzaSyBaf3a0lbvF-lZwXh0lo0X-OStQ39ffMcI",
    authDomain: "impactcar-iccmtl.firebaseapp.com",
    projectId: "impactcar-iccmtl",
    storageBucket: "impactcar-iccmtl.firebasestorage.app",
    messagingSenderId: "266981258443",
    appId: "1:266981258443:web:888a2b789f65610440d74e",
    measurementId: "G-69Y3Q48NHP"
}
export const app = initializeApp(firebaseConfig)

export const auth = initializeAuth(app, {
    persistence: browserLocalPersistence
})

// // Initialize Firebase Cloud Messaging and get a reference to the service
// const messaging = getMessaging(app);
//
// export const requestForToken = () => {
//   return getToken(messaging, {
//     vapidKey:
//       'BC05xZXYmu1220hXh4xIcP03usHEJtdpr4xxPbUfLkj0pcTAAEYfyjjakepvKGKjgYwXYJ_g_HPw66b6Q3HIs-Y'
//   }).then((currentToken) => {
//       if (currentToken) {
//         console.log('current token for client: ', currentToken);
//         // Perform any other necessary action with the token
//       } else {
//         // Show permission request UI
//         console.log('No registration token available. Request permission to generate one.');
//       }
//     })
//     .catch((err) => {
//       console.log('An error occurred while retrieving token. ', err);
//     });
// };

/* export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('payload', payload);
      resolve(payload);
    });
  }); */
